import styled from 'styled-components';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 30px;
    flex-wrap: wrap;
    width: 100%;
`;

export const List = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    @media(min-width: 1180px) {
        flex-direction: row;
        justify-content: space-between;
        margin-top: 25px;
    }
`;

export const IconImg = styled.img`
    max-width: 100%;
    max-height: 100%;
`;

export const Title = styled.h2`
    margin-top: 0;
    margin-top: 50px;
    margin-bottom: 25px;
    font-family: 'robotoLight', Arial, Helvetica, sans-serif;
    font-size: 24px;
    line-height: 30px;
    font-weight: 300;
    color: ${COLORS.black};
`;

export const ItemText = styled.div`
    margin-bottom: 0;
    width: calc(100% - 60px - 20px);
`;

export const ItemTitle = styled.p`
    font-size: 16px;
    line-height: 24px;
    font-weight: 300;
    color: ${COLORS.black};
    font-family: 'robotoRegular', Arial, Helvetica, sans-serif;
    margin: 0 0 10px 0;
`;

export const ItemRescription = styled.p`
    margin: 0;
    font-size: 16px;
    line-height: 24px;
    font-family: 'robotoLight', Arial, Helvetica, sans-serif;
    font-weight: 300;
    color: ${COLORS.black};
`;

export const Icon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  margin-right: 20px;
  margin-bottom: 20px;
  background: ${COLORS.white};
  border-radius: 50%;
  @media (min-width: 768px) {
    margin-bottom: 0;
  }
`;

export const Item = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    width: calc((100% / ${p => p.columns}) - 15px);
    margin-bottom: 50px;
    @media(max-width: 1179px) {
        width: 100%;
        margin-bottom: 20px;
    }
`;
